import type { Contract, ContractStatus, ContractType } from './types';

export const CONTRACT_STATUSES: { value: ContractStatus; labelKey: string; color: string }[] = [
  {
    value: 'draft',
    labelKey: 'contract.status.draft',
    color: 'bg-gray-100 text-gray-800 dark:bg-gray-700 dark:text-gray-300',
  },
  {
    value: 'active',
    labelKey: 'contract.status.active',
    color: 'bg-green-100 text-green-800 dark:bg-green-900/30 dark:text-green-300',
  },
  {
    value: 'completed',
    labelKey: 'contract.status.completed',
    color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  },
  {
    value: 'cancelled',
    labelKey: 'contract.status.cancelled',
    color: 'bg-red-100 text-red-800 dark:bg-red-900/30 dark:text-red-300',
  },
];

export const CONTRACT_TYPES: { value: ContractType; labelKey: string; color: string }[] = [
  {
    value: 'rental',
    labelKey: 'contract.type.rental',
    color: 'bg-yellow-100 text-yellow-800 dark:bg-yellow-900/30 dark:text-yellow-300',
  },
  {
    value: 'service',
    labelKey: 'contract.type.service',
    color: 'bg-purple-100 text-purple-800 dark:bg-purple-900/30 dark:text-purple-300',
  },
  {
    value: 'sales',
    labelKey: 'contract.type.sales',
    color: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300',
  },
];

export const MOCK_CONTRACTS: Contract[] = [
  {
    id: 'c-001',
    contractNumber: 'SZ-2026-0001',
    type: 'rental',
    status: 'active',
    rentalId: 'r-001',
    rentalNumber: 'B-2026-0042',
    partnerId: 'p-001',
    partnerName: 'Kovács és Társa Kft.',
    partnerAddress: '1134 Budapest, Váci út 35.',
    partnerPhone: '+36 1 234 5678',
    createdAt: '2026-01-15T09:00:00Z',
    startDate: '2026-01-15',
    expectedEndDate: '2026-01-22',
    signedAt: '2026-01-15T09:30:00Z',
    items: [
      {
        id: 'ci-001',
        productId: 'prod-003',
        description: 'Hilti TE 60-ATC-AVR kombikalapács',
        quantity: 1,
        dailyRate: 8500,
        totalAmount: 59500,
      },
    ],
    totalAmount: 59500,
    depositAmount: 150000,
    depositPaid: true,
    terms:
      'A bérlő köteles a gépet eredeti állapotban, tisztán visszaszolgáltatni. Sérülés esetén a javítási költséget a kaucióból levonjuk.',
    notes: 'Telefonos egyeztetés után hosszabbítás lehetséges.',
    createdBy: 'Kiss Anna',
    signedByPartner: true,
    signedByStaff: true,
  },
  {
    id: 'c-002',
    contractNumber: 'SZ-2026-0002',
    type: 'rental',
    status: 'active',
    rentalId: 'r-002',
    rentalNumber: 'B-2026-0045',
    partnerId: 'p-003',
    partnerName: 'Építőipari Megoldások Zrt.',
    partnerAddress: '2040 Budaörs, Gyár utca 88.',
    partnerPhone: '+36 1 555 1234',
    createdAt: '2026-01-16T14:00:00Z',
    startDate: '2026-01-16',
    expectedEndDate: '2026-02-16',
    signedAt: '2026-01-16T14:30:00Z',
    items: [
      {
        id: 'ci-002',
        productId: 'prod-009',
        description: 'Makita HR2470 SDS-Plus fúrókalapács',
        quantity: 3,
        dailyRate: 3500,
        totalAmount: 325500,
      },
      {
        id: 'ci-003',
        productId: 'prod-003',
        description: 'Hilti TE 60-ATC-AVR kombikalapács',
        quantity: 1,
        dailyRate: 8500,
        totalAmount: 263500,
      },
    ],
    totalAmount: 589000,
    depositAmount: 230000,
    depositPaid: true,
    terms: 'Hosszú távú bérleti szerződés. Havi elszámolás, havi számlázás.',
    createdBy: 'Szabó Béla',
    signedByPartner: true,
    signedByStaff: true,
  },
  {
    id: 'c-003',
    contractNumber: 'SZ-2026-0003',
    type: 'rental',
    status: 'completed',
    rentalId: 'r-003',
    rentalNumber: 'B-2026-0038',
    partnerId: 'p-002',
    partnerName: 'Szabó Péter',
    partnerAddress: '2030 Érd, Fő utca 12.',
    partnerPhone: '+36 70 987 6543',
    partnerIdNumber: '123456AB',
    createdAt: '2026-01-10T10:00:00Z',
    startDate: '2026-01-10',
    expectedEndDate: '2026-01-12',
    actualEndDate: '2026-01-12',
    signedAt: '2026-01-10T10:15:00Z',
    items: [
      {
        id: 'ci-004',
        productId: 'prod-009',
        description: 'Makita HR2470 SDS-Plus fúrókalapács',
        quantity: 1,
        dailyRate: 3500,
        totalAmount: 10500,
      },
    ],
    totalAmount: 10500,
    depositAmount: 40000,
    depositPaid: true,
    notes: 'Kaució visszaadva, gép hibátlanul visszahozva.',
    createdBy: 'Kiss Anna',
    signedByPartner: true,
    signedByStaff: true,
  },
  {
    id: 'c-004',
    contractNumber: 'SZ-2026-0004',
    type: 'rental',
    status: 'draft',
    partnerId: 'p-007',
    partnerName: 'Dunántúli Építők Kft.',
    partnerAddress: '9021 Győr, Révai utca 10.',
    partnerPhone: '+36 96 123 456',
    createdAt: '2026-01-18T08:00:00Z',
    startDate: '2026-01-20',
    expectedEndDate: '2026-01-27',
    items: [
      {
        id: 'ci-005',
        productId: 'prod-003',
        description: 'Hilti TE 60-ATC-AVR kombikalapács',
        quantity: 2,
        dailyRate: 8500,
        totalAmount: 119000,
      },
    ],
    totalAmount: 119000,
    depositAmount: 300000,
    depositPaid: false,
    terms: 'Standard bérleti feltételek.',
    createdBy: 'Szabó Béla',
    signedByPartner: false,
    signedByStaff: false,
  },
  {
    id: 'c-005',
    contractNumber: 'SZ-2025-0089',
    type: 'rental',
    status: 'cancelled',
    rentalId: 'r-old',
    rentalNumber: 'B-2025-0412',
    partnerId: 'p-004',
    partnerName: 'Probléma Bt.',
    partnerAddress: '1111 Budapest, Rossz utca 1.',
    partnerPhone: '+36 1 111 2222',
    createdAt: '2025-12-01T10:00:00Z',
    startDate: '2025-12-01',
    expectedEndDate: '2025-12-08',
    items: [
      {
        id: 'ci-006',
        productId: 'prod-009',
        description: 'Makita HR2470 SDS-Plus fúrókalapács',
        quantity: 1,
        dailyRate: 3500,
        totalAmount: 24500,
      },
    ],
    totalAmount: 24500,
    depositAmount: 40000,
    depositPaid: true,
    notes: 'Szerződés visszavonva - ügyfél feketelistán.',
    createdBy: 'Admin',
    signedByPartner: true,
    signedByStaff: true,
  },
];
